<template>
    <div class="property-list" v-if="currentComponent">
        <h3>{{ $t('contrato_rastreabilidade.messages.main_list_title') }}</h3>
        <el-card>
            <component
                :is="currentComponent"
                ref="FarmListComponent"
                :selected.sync="selectedFarms"
                :operations="getOperationList"
            />
        </el-card>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'ReportApproverList',
    props: {
        selected: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/traceability-contract/views/pages/main/components/contract-approver-list/py.vue'
                    )
            }
        };
    },
    mounted() {
        this.$store.commit('traceabilityContractModule/CLEAR_FILTER');
        this.filter.type = 3;
    },
    computed: {
        ...mapGetters('traceabilityContractModule', ['getOperationList']),
        ...mapState('traceabilityContractModule', ['filter']),
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        },
        selectedFarms: {
            get() {
                return this.selected;
            },
            set(value) {
                this.$emit('update:selected', value);
            }
        },
        filterHandler() {
            return [
                this.filter.page,
                this.filter.size,
                this.filter.contract_number
            ];
        }
    },
    watch: {
        filterHandler() {
            this.fetchOperations();
        }
    },
    methods: {
        ...mapActions('traceabilityContractModule', ['fetchOperations'])
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}
</style>
